"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _util = _interopRequireDefault(require("util"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class ConsoleLogger {
  debug(...tokens) {
    console.info(_util.default.format(...tokens));
  }

}

exports.default = ConsoleLogger;
module.exports = exports.default;
//# sourceMappingURL=ConsoleLogger.js.map